import {
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@fluentui/react-components";
import { useMfaEndSuccess } from "./mfaEndSuccess/useMfaEndSuccess";
import { translate } from "@/config/translator";
import { MfaSetupContext } from "../useMfaSetup";
import PspButton from "@/components/pspButton/PspButton";

type MfaEndSuccessProps = {
  onNext: () => void;
  mfaSetupContext: MfaSetupContext;
};

export function MfaEndSuccess({ onNext, mfaSetupContext }: MfaEndSuccessProps) {
  const { lang, onNextWrapper } = useMfaEndSuccess({ onNext, mfaSetupContext });
  return (
    <>
      <DialogTitle>{translate("successfullySetUp", lang)}</DialogTitle>
      <DialogContent className="text-font-secondary">
        {translate("twoFactorAuthSetupSuccessfully", lang)}
      </DialogContent>
      <DialogActions>
        <PspButton appearance="primary" onClick={onNextWrapper}>
          {translate("finish", lang)}
        </PspButton>
      </DialogActions>
    </>
  );
}
